import React from "react";
import icon from "../../../Assets/invoice (1).svg";

const ProductTable = ({
  records,
  selectedProductIds,
  onViewInvoice,
  onApprove,
  onReject,
}) => {
  // Sort the records to show the latest product at the top
  const sortedRecords = [...records].sort((a, b) => {
    return new Date(b.purchaseDate) - new Date(a.purchaseDate); // Sort by purchaseDate in descending order
  });

  return (
    <div className="overflow-x-auto">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {sortedRecords.map((record) => (
          <div
            key={record._id}
            className={`bg-white border-2 border-dashed shadow-[0px_10px_60px_0px_#E2ECF980] border-gray-200 p-4 sm:p-6 rounded-lg ${
              selectedProductIds.includes(record._id) ? "bg-gray-100" : ""
            }`}
          >
            <div className="mb-4">
              {/* Product Name */}
              <div className="flex justify-between mb-2">
                <div className="font-semibold text-[#B5B7C0] text-sm">Product Name</div>
                <div className="font-semibold text-[#292D32] text-sm">{record.productName}</div>
              </div>

              {/* Product ID */}
              <div className="flex justify-between mb-2">
                <div className="font-semibold text-[#B5B7C0] text-sm">Product ID</div>
                <div className="font-semibold text-[#292D32] text-sm">{record.productID}</div>
              </div>

              {/* Serial No (always visible on mobile) */}
              <div className="flex justify-between mb-2">
                <div className="font-semibold text-[#B5B7C0] text-sm">Serial No</div>
                <div className="font-semibold text-[#292D32] text-sm">{record.serialNo}</div>
              </div>

              {/* Model No (always visible on mobile) */}
              <div className="flex justify-between mb-2">
                <div className="font-semibold text-[#B5B7C0] text-sm">Model No</div>
                <div className="font-semibold text-[#292D32] text-sm">{record.modelNo}</div>
              </div>

              {/* Purchase Date */}
              <div className="flex justify-between mb-2">
                <div className="font-semibold text-[#B5B7C0] text-sm">Purchase Date</div>
                <div className="font-semibold text-[#292D32] text-sm">
                  {new Date(record.purchaseDate).toLocaleDateString()}
                </div>
              </div>

              {/* Expiry Date */}
              <div className="flex justify-between mb-2">
                <div className="font-semibold text-[#B5B7C0] text-sm">Expiry Date</div>
                <div className="font-semibold text-[#292D32] text-sm">
                  {new Date(record.expiryDate).toLocaleDateString()}
                </div>
              </div>

              {/* Status */}
              <div className="flex justify-between mb-2">
                <div className="font-semibold text-[#B5B7C0] text-sm">Status</div>
                <div
                  className={`font-semibold text-sm px-3 py-1 w-auto min-w-[120px] text-center rounded-2xl ${
                    record.status === "Approved"
                      ? "bg-[#15B24B1A] text-green-500"
                      : record.status === "Rejected"
                      ? "bg-[#F871711A] text-red-500"
                      : record.status === "In process"
                      ? "bg-blue-500 text-white"
                      : "bg-gray-300 text-black"
                  }`}
                >
                  {record.status}
                </div>
              </div>

              {/* Invoice Section */}
              <div className="flex justify-between mb-2">
                <div className="text-[#B5B7C0] font-semibold text-sm">Invoice</div>
                <div>
                  <button
                    onClick={() => onViewInvoice(record.invoice)}
                    className="text-white font-bold px-3 py-2 text-sm rounded-full hover:bg-[#1C50A3CC] flex items-center"
                    style={{ backgroundColor: "#1C50A3" }}
                  >
                    <img
                      src={icon} // Replace with the path to your icon image
                      alt="Invoice Icon"
                      className="w-5 h-5 mr-2"
                    />
                    View Invoice
                  </button>
                </div>
              </div>

              {/* Approve and Reject Buttons */}
              <div className="flex flex-col sm:flex-row justify-between mt-4 gap-2">
                <button
                  onClick={() => onReject(record._id)}
                  className="bg-[#E0E0E0] text-black px-4 py-2 text-sm font-medium rounded w-full hover:bg-[#D6D6D6]"
                >
                  Reject
                </button>

                <button
                  onClick={() => onApprove(record._id)}
                  className="bg-gradient-to-r from-[#1C50A3] to-[#2B68C8] text-white px-4 py-2 font-medium rounded w-full hover:from-[#1A4788] hover:to-[#255FA5]"
                >
                  Approve
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProductTable;
